export const environment = {
  production: false,
  demo: false,
  qa: false,
  urlApi: `https://reqres.in/`,
  urlApiMonitor: `https://bxupsiuki7.execute-api.us-east-1.amazonaws.com/beta/`,
  // urlRepotData: `https://backend-pe.back2w.com/api`,
  // Se conecta a BI
  urlRepotData: `https://b2w-bi-api.wokko.io:8443/b2w`,
  // urlRepotData: `https://localhost:8443/b2w`,
  keyStorage: `STORE_REDUX`,
  urlContactTracing: `https://contact-tracing.wokko.io:8441/contact-tracing`,
  companyInfo: `https://b2w-api.wokko.io:8441/b2w`,
  // TODO change this key
  mapApiKey: `AIzaSyCE6jH_mP9s3HL3d5kHcn5f6sV7T6IeeAs`,
};
